import React from "react";
import FatherLayout from "../../components/Parents/FatherLayout";
import Questions from "../../components/Parents/FAQ/Questions";

function FAQ() {
    return (
        <FatherLayout title="FAQS" showWelcomeBanner={true}>
            <Questions/>
        </FatherLayout>
    );
}

export default FAQ;
